export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  views: number;
  likes: number;
  comments: number;
  duration: string;
  tags: string[];
  thumbnail: string;
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '当你的猫咪第一次见到扫地机器人，反应太真实了',
    excerpt: '家里的猫咪第一次见到扫地机器人时，吓得直接跳上了天花板，这反应也太好笑了吧！全程高能预警。',
    content: `<p>今天给大家分享一个超级搞笑的瞬间——我家那只平时高冷无比的英短猫咪"团子"，第一次见到扫地机器人的反应。</p>
<p>事情是这样的，前几天我终于入手了一台扫地机器人，满心欢喜地开箱试用。谁知道当机器人开始在地上移动的时候，正在沙发上慵懒晒太阳的团子突然瞪大了眼睛。</p>
<p>它先是用一种"这什么玩意儿"的表情盯着机器人看了大概三秒钟，然后做出了一个让我笑到肚子疼的动作——直接从沙发弹射起飞，跳到了将近两米高的柜子顶上！</p>
<p>整个过程大概只有0.5秒，我甚至来不及掏出手机录像。团子在柜子顶上瑟瑟发抖，小心翼翼地盯着下面那个"不速之客"，表情既警惕又委屈。</p>
<p>更好笑的是，扫地机器人在客厅里转了一圈后慢慢靠近了柜子下方，团子直接炸毛了，发出"呜呜"的警告声。但机器人丝毫不为所动，继续它的清洁工作。</p>
<p>大概过了十分钟，团子才开始慢慢地、慢慢地从柜子上下来，用爪子试探性地拍了拍机器人的外壳。发现这个铁疙瘩并不会攻击它之后，它开始跟在机器人后面走，像是在监视一个可疑分子。</p>
<p>现在三天过去了，团子已经完全适应了扫地机器人的存在，甚至有时候会坐在上面"搭便车"，简直不要太可爱。</p>
<p>你们家的宠物第一次见到扫地机器人是什么反应呢？欢迎在评论区分享！</p>`,
    categorySlug: 'gaoxiao',
    author: '团子铲屎官',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20style%20cat%20avatar%20with%20warm%20orange%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20friendly%20expression%2C%20clean%20edges%2C%20soft%20colors&width=100&height=100&seq=avatar-a1&orientation=squarish',
    publishDate: '2026-08-05',
    views: 128000,
    likes: 35200,
    comments: 2847,
    duration: '02:35',
    tags: ['猫咪', '搞笑', '日常', '宠物'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fluffy%20orange%20cat%20sitting%20on%20top%20of%20a%20robot%20vacuum%20cleaner%20in%20a%20bright%20living%20room%2C%20funny%20and%20cute%20scene%2C%20warm%20natural%20lighting%2C%20clean%20modern%20interior%2C%20photorealistic%20style%2C%20soft%20shadows%2C%20high%20detail&width=800&height=450&seq=article-thumb-a1&orientation=landscape',
    featured: true,
  },
  {
    id: 'a2',
    title: '五分钟学会做正宗麻辣小龙虾，比夜市还好吃',
    excerpt: '夏天怎么能少了小龙虾？今天教你一招，在家就能做出比夜市摊还正宗的麻辣小龙虾，简单易学！',
    content: `<p>夏天到了，又到了吃小龙虾的季节！每次路过夜市摊都被那诱人的香味勾引，但是外面吃一顿动辄两三百，其实自己在家做超简单！</p>
<p>今天就给大家分享我研究了很久的麻辣小龙虾配方，保证做出来的味道比外面还好吃。</p>
<p><strong>准备食材：</strong></p>
<p>小龙虾2斤、干辣椒50克、花椒30克、豆瓣酱3勺、啤酒一罐、葱姜蒜适量、八角2个、桂皮1块、香叶3片。</p>
<p><strong>制作步骤：</strong></p>
<p>第一步：清洗小龙虾。这一步最重要！先用刷子把每只虾的腹部和钳子刷干净，然后用剪刀剪掉虾头前端三分之一处，挑出虾胃，最后捏住虾尾中间那片拧一下拉出虾线。</p>
<p>第二步：热锅冷油，油要多放，大概半锅油。油温七成热时下入处理好的小龙虾，炸至虾壳变红、虾肉卷曲，捞出控油。</p>
<p>第三步：锅中留底油，放入葱姜蒜爆香，加入豆瓣酱炒出红油，再放入干辣椒、花椒、八角、桂皮、香叶炒出香味。</p>
<p>第四步：倒入炸好的小龙虾，翻炒均匀，让每只虾都裹上调料。</p>
<p>第五步：倒入一罐啤酒，大火煮开后转中小火焖10分钟，让虾肉充分吸收汤汁的味道。</p>
<p>第六步：开大火收汁，撒上葱花和香菜，出锅！</p>
<p>这样做出来的小龙虾，虾肉Q弹，麻辣鲜香，一口下去满满的幸福感。配上一杯冰啤酒，绝了！</p>
<p>赶紧试试吧，学会了记得来评论区交作业哦~</p>`,
    categorySlug: 'meishi',
    author: '吃货小明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20chef%20avatar%20with%20green%20teal%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20holding%20a%20spatula%2C%20warm%20smile%2C%20clean%20edges&width=100&height=100&seq=avatar-a2&orientation=squarish',
    publishDate: '2026-08-04',
    views: 256000,
    likes: 68400,
    comments: 5230,
    duration: '05:18',
    tags: ['美食', '小龙虾', '家常菜', '麻辣'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Delicious%20spicy%20crayfish%20on%20a%20large%20plate%20with%20red%20chili%20peppers%20and%20green%20scallions%2C%20steaming%20hot%20food%20photography%2C%20dark%20wooden%20table%2C%20warm%20ambient%20lighting%2C%20appetizing%20presentation%2C%20high%20detail%20food%20photography&width=800&height=450&seq=article-thumb-a2&orientation=landscape',
    featured: true,
  },
  {
    id: 'a3',
    title: '一个人背包去大理，三天两夜只花了500块',
    excerpt: '大理真的是一座来了就不想走的城市！分享我的穷游攻略，三天两夜人均不到500元，吃好玩好住好。',
    content: `<p>上周末我终于实现了心心念念的大理之旅！作为一个学生党，预算有限但我又不想将就，所以精心规划了这趟三天两夜的旅程。</p>
<p>先说说总体花费：往返高铁218元（从昆明出发），住宿两晚150元（青旅床位），吃饭160元，景点门票等合计不到500元。是不是很香？</p>
<p><strong>Day 1：古城漫步</strong></p>
<p>中午到达大理站后，坐8路公交直达古城，票价2元。入住提前订好的青旅，放下行李就开始逛古城。走在石板路上，两边是白族特色的建筑，抬头就能看到苍山上的云雾。</p>
<p>下午去了人民路和洋人街，各种手工艺品店、咖啡馆、小酒吧，文艺气息满满。傍晚在古城南门附近找了家小店吃了碗耙肉饵丝，只要15块，超级好吃！</p>
<p><strong>Day 2：环洱海骑行</strong></p>
<p>这是最精彩的一天！在古城租了一辆电动车，60元一天。从古城出发，沿着环海西路一路向北。沿途的风景简直美到窒息——左边是波光粼粼的洱海，右边是郁郁葱葱的苍山。</p>
<p>在喜洲古镇停下来吃了个喜洲粑粑，逛了逛白族民居。然后继续骑到双廊，坐在洱海边发呆看日落，那一刻感觉所有烦恼都消失了。</p>
<p><strong>Day 3：苍山徒步</strong></p>
<p>最后一天选择了苍山徒步。从感通索道上山，沿着玉带路走了一段，空气清新得让人想打包带走。在山上看洱海全貌，整个大理尽收眼底。</p>
<p>下午坐高铁回昆明，虽然有些疲惫，但心里满满的都是美好的回忆。</p>
<p>如果你也想一个人出去走走，大理绝对是个好选择！</p>`,
    categorySlug: 'lvxing',
    author: '背包小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20traveler%20avatar%20with%20backpack%2C%20warm%20brown%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20adventurous%20vibe%2C%20clean%20edges&width=100&height=100&seq=avatar-a3&orientation=squarish',
    publishDate: '2026-08-03',
    views: 189000,
    likes: 45200,
    comments: 3678,
    duration: '06:42',
    tags: ['旅行', '大理', '穷游', '攻略', '洱海'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Dali%20ancient%20town%20with%20Cangshan%20mountain%20in%20background%20and%20Erhai%20lake%20on%20a%20sunny%20day%2C%20traditional%20Bai%20architecture%2C%20blue%20sky%20with%20white%20clouds%2C%20travel%20photography%2C%20warm%20golden%20light%2C%20peaceful%20atmosphere&width=800&height=450&seq=article-thumb-a3&orientation=landscape',
    featured: true,
  },
  {
    id: 'a4',
    title: '用街头钢琴弹了一首《晴天》，路人全都跟着唱起来了',
    excerpt: '在商场看到一台街头钢琴，心血来潮弹了周杰伦的《晴天》，没想到引发了一场大合唱，太感动了！',
    content: `<p>昨天去商场逛街的时候，在一楼大厅看到了一台公共钢琴，上面写着"免费弹奏，分享音乐"。作为一个学了十年钢琴的音乐爱好者，我忍不住坐了下来。</p>
<p>犹豫了一下该弹什么，最后选择了周杰伦的《晴天》——这首陪伴了无数人青春的歌。前奏一响起来，立刻有几个逛街的年轻人停下脚步看了过来。</p>
<p>弹到副歌部分的时候，神奇的事情发生了。先是旁边一个女生轻轻跟着哼唱，然后她的朋友也加入了进来，再然后周围越来越多的陌生人开始一起唱：</p>
<p>"从前从前，有个人爱你很久，但偏偏，风渐渐，把距离吹得好远..."</p>
<p>那个场面真的太震撼了！大概有三四十个陌生人，不同的年龄，不同的穿着，但在那一刻，大家因为一首歌连接在了一起。有人眼眶都红了，可能是想起了某个重要的人吧。</p>
<p>弹完之后，大家自发地鼓掌，还有人走过来跟我说"弹得太好了"。有个阿姨说这首歌让她想起了她大学时候的日子。音乐真的是一种神奇的语言。</p>
<p>这次经历让我更加坚定了继续做音乐创作的决心。希望我的音乐也能在某一天，触动某个人的心弦。</p>
<p>你们最喜欢周杰伦的哪首歌呢？</p>`,
    categorySlug: 'yinyue',
    author: '钢琴小张',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20musician%20avatar%20playing%20piano%2C%20warm%20orange%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20musical%20notes%20floating%2C%20clean%20edges&width=100&height=100&seq=avatar-a4&orientation=squarish',
    publishDate: '2026-08-02',
    views: 356000,
    likes: 98200,
    comments: 7856,
    duration: '04:12',
    tags: ['音乐', '钢琴', '周杰伦', '街头', '合唱'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20person%20playing%20a%20grand%20piano%20in%20a%20bright%20shopping%20mall%20atrium%2C%20crowd%20of%20people%20gathered%20around%20singing%20together%2C%20warm%20lighting%2C%20emotional%20atmosphere%2C%20modern%20architecture%2C%20heartwarming%20scene%2C%20photorealistic&width=800&height=450&seq=article-thumb-a4&orientation=landscape',
    featured: false,
  },
  {
    id: 'a5',
    title: '《黑神话：悟空》隐藏BOSS无伤通关攻略，手残党也能学会',
    excerpt: '全网最详细的隐藏BOSS打法解析，每个招式拆解到位，配合慢动作演示，包教包会！',
    content: `<p>《黑神话：悟空》上线以来，隐藏BOSS"赤髯龙"成了无数玩家的噩梦。今天我就来手把手教大家如何无伤通关！</p>
<p>首先说一下装备配置：推荐使用"金刚不坏"身法和"分身术"技能组合。武器方面选择"如意金箍棒·改"，这件武器对龙类敌人有额外伤害加成。</p>
<p><strong>第一阶段：远程攻击阶段</strong></p>
<p>BOSS开局会释放三连火球，注意脚下红圈预警。看到红圈出现的瞬间，向侧方翻滚两次即可完美躲避。火球结束后会有2秒硬直，这是输出的最佳时机——冲上去打一套轻攻击连段然后立刻后撤。</p>
<p><strong>第二阶段：近战阶段（50%血量以下）</strong></p>
<p>这是最难的部分。BOSS会使用扫尾攻击，范围极大。判断方法：BOSS会把头偏向左侧——这时候要往右边闪避。右侧同理。</p>
<p>还有一个致命招式是"龙息喷吐"，看到BOSS脖子膨胀发红时，立刻使用"金刚不坏"硬抗，或者跑到BOSS身后。</p>
<p><strong>关键技巧：分身术的正确使用时机</strong></p>
<p>当BOSS血量降到30%左右时，它会进入狂暴状态，攻击频率翻倍。这时候使用分身术，让分身吸引仇恨，本体绕到背后疯狂输出。一套爆发下来基本能带走。</p>
<p>最后祝大家都能顺利通关！有什么问题可以在评论区交流~</p>`,
    categorySlug: 'youxi',
    author: '游戏达人老李',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20gamer%20avatar%20with%20headset%2C%20teal%20green%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20cool%20vibe%2C%20clean%20edges&width=100&height=100&seq=avatar-a5&orientation=squarish',
    publishDate: '2026-08-01',
    views: 412000,
    likes: 115000,
    comments: 9230,
    duration: '08:55',
    tags: ['游戏', '黑神话悟空', '攻略', 'BOSS', '无伤'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20game%20screenshot%20style%20scene%20with%20a%20mythical%20Chinese%20dragon%20boss%20and%20a%20monkey%20warrior%20in%20combat%2C%20dramatic%20lighting%2C%20ancient%20Chinese%20temple%20ruins%20background%2C%20cinematic%20composition%2C%20high%20detail&width=800&height=450&seq=article-thumb-a5&orientation=landscape',
    featured: true,
  },
  {
    id: 'a6',
    title: '为什么猫从高处跳下来不会受伤？物理学解释来了',
    excerpt: '猫咪的"高空翻正反射"到底是怎么回事？用物理学原理为你揭秘猫咪的神奇能力。',
    content: `<p>养猫的朋友肯定注意过一个现象：无论猫咪从什么姿势坠落，它总能在空中翻转并用四脚着地。这个神奇的能力在物理学上叫做"高空翻正反射"。</p>
<p>今天就来用通俗易懂的物理学知识，给大家解释这个有趣的现象。</p>
<p><strong>第一步：感知方向</strong></p>
<p>猫咪的内耳前庭系统非常发达，比人类灵敏得多。当猫咪开始坠落时，它的内耳能瞬间感知到重力的方向，判断出"哪边是下"。</p>
<p><strong>第二步：分段旋转</strong></p>
<p>这是最关键的一步。猫咪的身体非常灵活，脊椎由50多块椎骨组成（人类只有33块）。它会把身体分成前后两段来旋转：</p>
<p>首先，猫咪会把前腿收拢、后腿伸开，利用角动量守恒的原理——前腿收拢减小了前半身的转动惯量，让前半身能快速旋转180度。</p>
<p>然后反过来，后腿收拢、前腿伸开，让后半身也旋转到位。整个过程只需要大约0.3秒！</p>
<p><strong>第三步：缓冲着陆</strong></p>
<p>四脚朝下后，猫咪会弓起背部，像弹簧一样吸收落地时的冲击力。它的脚掌上还有厚厚的肉垫，起到天然减震的作用。</p>
<p>研究表明，猫咪从2-6层楼高度坠落时存活率最高，因为这段时间足够它完成翻正反射并达到终端速度。有趣的是，从更高楼层坠落的猫咪反而受伤更重，因为冲击力太大了。</p>
<p>但还是要提醒大家：一定要封好窗户，不要让猫咪有跳楼的机会哦！</p>`,
    categorySlug: 'zhishi',
    author: '科普阿涛',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20scientist%20avatar%20with%20glasses%2C%20warm%20brown%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20holding%20a%20book%2C%20clean%20edges&width=100&height=100&seq=avatar-a6&orientation=squarish',
    publishDate: '2026-07-30',
    views: 98000,
    likes: 28400,
    comments: 1956,
    duration: '03:48',
    tags: ['科普', '物理', '猫咪', '知识'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cat%20mid-air%20flipping%20its%20body%20gracefully%20with%20physics%20diagrams%20and%20formulas%20overlaid%20artistically%2C%20clean%20white%20background%2C%20educational%20style%2C%20dynamic%20pose%2C%20high%20speed%20photography%20feel%2C%20scientific%20illustration&width=800&height=450&seq=article-thumb-a6&orientation=landscape',
    featured: false,
  },
  {
    id: 'a7',
    title: '零基础健身入门：7个动作练出完美腹肌',
    excerpt: '不去健身房也能练出好身材！分享7个居家腹肌训练动作，每天只需15分钟，坚持一个月见效。',
    content: `<p>想要练出腹肌但又不想去健身房？没问题！今天就给大家分享一套在家就能做的腹肌训练方案。</p>
<p>这套方案一共7个动作，每天只需要15分钟，不需要任何器械。关键是坚持，一个月后你就能看到明显变化！</p>
<p><strong>动作一：平板支撑（30秒×3组）</strong></p>
<p>双肘撑地，与肩同宽，身体保持一条直线。注意不要塌腰，核心收紧。这是激活核心肌群的基础动作。</p>
<p><strong>动作二：卷腹（15次×3组）</strong></p>
<p>仰卧屈膝，双手放在耳侧。用腹部力量将上半身卷起，注意是"卷"不是"起"，下巴不要贴胸口。</p>
<p><strong>动作三：俄罗斯转体（20次×3组）</strong></p>
<p>坐姿身体后仰45度，双脚离地，双手合十左右转动。这个动作主要训练腹外斜肌，帮你练出人鱼线。</p>
<p><strong>动作四：仰卧抬腿（15次×3组）</strong></p>
<p>仰卧双腿并拢，用下腹力量将腿抬起至90度，然后缓慢放下但不要触地。注意腰部要贴紧地面。</p>
<p><strong>动作五：登山者（30秒×3组）</strong></p>
<p>俯卧撑起始姿势，交替将膝盖向胸口方向提拉。保持核心收紧，速度可以快一些，这个动作燃脂效果超棒。</p>
<p><strong>动作六：侧平板支撑（每侧20秒×3组）</strong></p>
<p>侧卧单肘撑地，身体呈一条直线，另一只手叉腰。这个动作针对侧腹肌。</p>
<p><strong>动作七：死虫式（每侧10次×3组）</strong></p>
<p>仰卧四肢朝天，交替放下对侧手脚，保持核心稳定。这个动作对新手非常友好，保护腰椎。</p>
<p>坚持就是胜利！记得搭配合理饮食，腹肌是在厨房练出来的哦~</p>`,
    categorySlug: 'yundong',
    author: '健身教练大刘',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20fitness%20trainer%20avatar%2C%20muscular%20friendly%20character%2C%20orange%20warm%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20clean%20edges&width=100&height=100&seq=avatar-a7&orientation=squarish',
    publishDate: '2026-07-29',
    views: 178000,
    likes: 52300,
    comments: 4102,
    duration: '04:35',
    tags: ['健身', '腹肌', '居家训练', '运动'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fit%20person%20doing%20ab%20exercises%20on%20a%20yoga%20mat%20in%20a%20bright%20minimalist%20living%20room%2C%20morning%20sunlight%20streaming%20through%20window%2C%20healthy%20lifestyle%2C%20clean%20aesthetic%2C%20motivational%20atmosphere%2C%20photorealistic&width=800&height=450&seq=article-thumb-a7&orientation=landscape',
    featured: false,
  },
  {
    id: 'a8',
    title: '养了只哈士奇之后，我的生活发生了翻天覆地的变化',
    excerpt: '自从家里来了一只哈士奇，每天都有拆不完的家和笑不完的料，养二哈真的需要一颗强大的心脏！',
    content: `<p>半年前，我做了人生中最疯狂的决定之一——养了一只哈士奇。我给它取名叫"拆迁办主任"，简称"拆总"。</p>
<p>今天就来分享养二哈这半年来的真实体验，给准备养哈士奇的朋友们一个参考。</p>
<p><strong>第一个月：天使降临</strong></p>
<p>刚到家的时候，小家伙怯生生的，躲在笼子里不敢出来。我心想：网上说的都是骗人的吧？这明明是个小天使啊！</p>
<p>呵呵，我太天真了。</p>
<p><strong>第二个月：原型毕露</strong></p>
<p>适应环境后的拆总，开始了它的表演。先是啃坏了三双拖鞋、两只遥控器、一个沙发角。最离谱的是有一天我回家，发现它把一卷卫生纸从客厅拖到了卧室，铺成了一条"白色的地毯"。</p>
<p><strong>第三个月：表情包大师</strong></p>
<p>哈士奇的表情真的是一绝。不管你在干什么，它总能用一种"你是傻子吗"的眼神看着你。我手机相册里现在80%都是拆总的表情包。</p>
<p><strong>现在：相爱相杀</strong></p>
<p>虽然它每天都在挑战我的底线，但每次下班回家看到它摇着尾巴冲过来的时候，所有的疲惫都消失了。它就像一个永远长不大的孩子，调皮但真诚。</p>
<p>养哈士奇的建议：一定要给足够的运动量（每天至少1小时），否则它会用拆家来消耗精力。还有就是，把你值钱的东西都收好，真的。</p>`,
    categorySlug: 'chongwu',
    author: '拆总他爹',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20dog%20owner%20avatar%20with%20husky%2C%20teal%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20funny%20expression%2C%20clean%20edges&width=100&height=100&seq=avatar-a8&orientation=squarish',
    publishDate: '2026-07-28',
    views: 234000,
    likes: 67400,
    comments: 5340,
    duration: '03:22',
    tags: ['宠物', '哈士奇', '搞笑', '日常'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20funny%20husky%20dog%20with%20a%20goofy%20expression%20sitting%20in%20a%20messy%20living%20room%20with%20torn%20pillows%20and%20scattered%20items%2C%20bright%20natural%20light%2C%20humorous%20scene%2C%20photorealistic%2C%20warm%20home%20interior&width=800&height=450&seq=article-thumb-a8&orientation=landscape',
    featured: false,
  },
  {
    id: 'a9',
    title: '程序员把老板的日常做成了搞笑短剧，笑到停不下来',
    excerpt: '一位程序员用AI工具把老板平时的经典语录做成了系列短剧，还原度百分百，已在办公室疯传。',
    content: `<p>最近我们公司的程序员小王火出圈了！他用AI视频生成工具，把老板每天的经典语录做成了一个系列搞笑短剧，在办公室群里传疯了。</p>
<p>事情的起因是这样的：上周五的周会上，老板又一次说出了那句经典台词——"这个需求很简单"。会议室里的所有人都默默地低下了头，因为大家都知道接下来会发生什么。</p>
<p>会后小王突发奇想，用AI工具把"这个需求很简单"做成了一个小短剧：一个古装将军在战场上对士兵说"这个仗很简单，你们明天就把敌国灭了吧"。士兵们的表情简直绝了。</p>
<p>这个视频在公司群里一发，瞬间炸了。大家纷纷贡献素材：</p>
<p>— "我们是一个团队"（配图：一个人在前面拉车，其他人在车上坐着）</p>
<p>— "要有owner意识"（配图：一个人被扔到荒岛上，旁边立着牌子"你是这座岛的owner"）</p>
<p>— "这个功能下周就要上线"（配图：一个人面对一座山，手里只有一把勺子）</p>
<p>最搞笑的是，老板看到之后居然也笑了，还在群里发了一句："创意不错，这个需求很简单，再拍十集吧。"</p>
<p>于是小王现在每天加班到凌晨...不是因为工作，而是在剪视频。</p>
<p>你们公司有没有类似的经典语录？欢迎分享！</p>`,
    categorySlug: 'gaoxiao',
    author: '社畜小李',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20programmer%20avatar%20with%20laptop%2C%20warm%20orange%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20tired%20but%20funny%20expression%2C%20clean%20edges&width=100&height=100&seq=avatar-a9&orientation=squarish',
    publishDate: '2026-07-27',
    views: 523000,
    likes: 156000,
    comments: 12450,
    duration: '03:15',
    tags: ['搞笑', '程序员', '职场', '短剧'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20funny%20office%20scene%20with%20programmers%20laughing%20at%20a%20computer%20screen%2C%20modern%20tech%20office%20with%20warm%20lighting%2C%20humorous%20mood%2C%20casual%20workplace%2C%20photorealistic&width=800&height=450&seq=article-thumb-a9&orientation=landscape',
    featured: false,
  },
  {
    id: 'a10',
    title: '在家做网红甜品"雪媚娘"，Q弹软糯巨简单',
    excerpt: '不用烤箱就能做的雪媚娘，外皮Q弹内馅丝滑，比外面甜品店卖的好吃十倍！',
    content: `<p>最近雪媚娘在甜品界可是红得发紫啊！今天教大家在家就能做的版本，零失败，手残党也能一次成功。</p>
<p><strong>准备材料：</strong></p>
<p>糯米粉200克、玉米淀粉60克、白砂糖80克、牛奶360毫升、黄油40克、淡奶油300毫升、水果适量（推荐芒果和草莓）。</p>
<p><strong>第一步：做外皮</strong></p>
<p>糯米粉、玉米淀粉、白砂糖混合均匀，加入牛奶搅拌至无颗粒。盖上保鲜膜（扎几个小孔），大火蒸25分钟。</p>
<p>蒸好后趁热加入黄油，用刮刀搅拌至黄油完全融化。等不烫手了戴上手套揉面，揉到光滑有弹性。包上保鲜膜放冰箱冷藏1小时。</p>
<p><strong>第二步：做内馅</strong></p>
<p>淡奶油加糖打发至硬性发泡。水果切成小块备用。</p>
<p><strong>第三步：组装</strong></p>
<p>案板上撒一些炒熟的糯米粉防粘。取出冷藏好的面团分成小剂子，擀成圆形薄皮。先挤一层奶油，放上水果，再挤一层奶油盖住水果，像包包子一样收口。</p>
<p>收口朝下放在纸托里，放入冰箱冷藏半小时定型。</p>
<p>一口咬下去，外皮QQ弹弹，奶油丝滑香甜，配上新鲜水果的酸甜，简直绝了！</p>
<p>学会了吗？赶紧动手试试吧！</p>`,
    categorySlug: 'meishi',
    author: '甜品控小芳',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20baker%20avatar%20with%20apron%2C%20teal%20green%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20sweet%20smile%2C%20clean%20edges&width=100&height=100&seq=avatar-a10&orientation=squarish',
    publishDate: '2026-07-26',
    views: 167000,
    likes: 48900,
    comments: 3567,
    duration: '04:56',
    tags: ['美食', '甜品', '雪媚娘', '烘焙'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20handmade%20mochi%20desserts%20on%20a%20ceramic%20plate%20with%20powdered%20sugar%2C%20soft%20natural%20lighting%2C%20pastel%20color%20palette%2C%20Japanese%20style%20dessert%20photography%2C%20elegant%20presentation%2C%20high%20detail&width=800&height=450&seq=article-thumb-a10&orientation=landscape',
    featured: false,
  },
  {
    id: 'a11',
    title: '在冰岛追极光的72小时，拍到了人生中最美的画面',
    excerpt: '专程飞到冰岛追极光，经历了两次失败后终于在第三天拍到了震撼的极光，值了！',
    content: `<p>极光，大概是每个旅行者心中的终极梦想之一。上个月我终于下定决心，飞了十几个小时到冰岛，专门去追极光。</p>
<p><strong>第一天：希望破灭</strong></p>
<p>到达雷克雅未克已经是晚上，极光预报显示KP指数5（很高！）。我兴奋得不行，租了车就冲向郊外。但天公不作美，云层太厚，等了一整晚什么都没看到。凌晨三点，我冻得瑟瑟发抖地回到酒店。</p>
<p><strong>第二天：再次失败</strong></p>
<p>不死心的我报了一个极光猎游团，跟着专业向导去追。这次天气好一些，云层很薄。向导带我们开到了远离城市灯光的黑沙滩附近。等到半夜两点，天空中隐约出现了一抹淡绿色的光芒——但实在太淡了，肉眼几乎看不太清，只有相机长曝光才能拍到。</p>
<p><strong>第三天：震撼降临</strong></p>
<p>第三天晚上，KP指数预报是4，天气晴朗。我决定一个人开车去斯奈山半岛，那里有草帽山做前景。晚上十一点左右，奇迹发生了——</p>
<p>先是天边出现了一抹浅绿色的光晕，然后慢慢地变亮、变宽，像一条发光的丝带在天空中舞动。绿色的极光越来越亮，中间还夹杂着紫色和粉色的光芒。整个天空都被染成了梦幻的颜色！</p>
<p>我架好三脚架，按下快门，记录下了人生中最美的一幕。站在冰岛的荒野中，头顶是绚丽的极光，周围一片寂静，那一刻我感觉全世界都属于我。</p>
<p>如果你也想追极光，9月到次年3月是冰岛的最佳观测期，记得提前查极光预报哦！</p>`,
    categorySlug: 'lvxing',
    author: '极光猎人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20photographer%20avatar%20with%20camera%2C%20warm%20brown%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20adventurous%20look%2C%20clean%20edges&width=100&height=100&seq=avatar-a11&orientation=squarish',
    publishDate: '2026-07-25',
    views: 298000,
    likes: 87600,
    comments: 6890,
    duration: '07:23',
    tags: ['旅行', '冰岛', '极光', '摄影'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20aurora%20borealis%20northern%20lights%20dancing%20over%20Iceland%20landscape%20with%20Kirkjufell%20mountain%20silhouette%2C%20green%20purple%20pink%20lights%20in%20night%20sky%2C%20snow%20covered%20ground%2C%20starry%20sky%2C%20breathtaking%20nature%20photography&width=800&height=450&seq=article-thumb-a11&orientation=landscape',
    featured: false,
  },
  {
    id: 'a12',
    title: '用尤克里里弹唱《小幸运》，温柔到让人想谈恋爱',
    excerpt: '最简单的四个和弦，零基础也能学会的尤克里里弹唱教程，附详细指法图解。',
    content: `<p>《小幸运》这首歌真的太好听了，而且用尤克里里弹唱特别简单！今天就教大家用四个和弦搞定这首歌。</p>
<p><strong>准备：调音</strong></p>
<p>尤克里里标准调音从四弦到一弦是G-C-E-A。调好音后就可以开始了。</p>
<p><strong>四个和弦指法：</strong></p>
<p>C和弦：无名指按一弦三品（最简单）</p>
<p>G和弦：食指按二弦二品，中指按一弦二品，无名指按三弦三品</p>
<p>Am和弦：中指按四弦二品</p>
<p>F和弦：食指按二弦一品，中指按四弦二品</p>
<p><strong>节奏型：</strong></p>
<p>下-下上-上下-下上（这是最基础的尤克里里节奏型，适合大部分歌曲）</p>
<p><strong>弹唱顺序：</strong></p>
<p>前奏：C - G - Am - F（弹两遍）</p>
<p>主歌：C - G - Am - F（循环）</p>
<p>副歌：C - G - Am - F（同样和弦，但节奏稍快）</p>
<p>是不是超级简单？就这四个和弦循环整首歌！关键是情感的投入，轻轻地唱出那种青春的感觉。</p>
<p>"原来你是我最想留住的幸运，原来我们和爱情曾经靠得那么近..."</p>
<p>学会了吗？拿起你的尤克里里试试吧~</p>`,
    categorySlug: 'yinyue',
    author: '尤克里里小艺',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20ukulele%20player%20avatar%2C%20warm%20orange%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20gentle%20smile%2C%20clean%20edges&width=100&height=100&seq=avatar-a12&orientation=squarish',
    publishDate: '2026-07-24',
    views: 145000,
    likes: 39800,
    comments: 2834,
    duration: '03:56',
    tags: ['音乐', '尤克里里', '弹唱', '教程', '小幸运'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20person%20playing%20ukulele%20by%20a%20sunny%20window%20with%20sheet%20music%20nearby%2C%20warm%20afternoon%20light%2C%20cozy%20room%2C%20peaceful%20atmosphere%2C%20music%20lifestyle%2C%20soft%20and%20dreamy%20photography&width=800&height=450&seq=article-thumb-a12&orientation=landscape',
    featured: false,
  },
  {
    id: 'a13',
    title: '王者荣耀新赛季上分攻略：三天从钻石到王者',
    excerpt: '新赛季版本大更新，分享当前版本最强英雄推荐和上分打法思路，助你轻松上分！',
    content: `<p>王者荣耀新赛季已经开启一周了，不知道大家的排位打得怎么样？今天来分享一下当前版本的强势英雄和上分思路。</p>
<p><strong>版本T0打野：澜</strong></p>
<p>新赛季澜的被动重做后强度直接拉满。推荐出装：追击刀锋、抵抗之靴、暗影战斧、宗师之力、破军、名刀。打法思路是前期快速刷野到4级，然后开始抓对抗路。澜的二技能突进配合大招可以将敌人推回塔下，击杀成功率非常高。</p>
<p><strong>版本T0射手：伽罗</strong></p>
<p>新版伽罗的一技能射程被小幅增强，配合暴击流出装输出爆炸。出装推荐：急速战靴、无尽战刃、影刃、破晓、泣血之刃、贤者的庇护。注意站位，伽罗只要活着就有输出。</p>
<p><strong>版本T0辅助：张飞</strong></p>
<p>张飞在这个版本依然是辅助一哥。保护能力顶级，开团能力也很强。出纯肉装：近卫荣耀、抵抗之靴、不祥征兆、魔女斗篷、霸者重装、复活甲。</p>
<p><strong>上分思路：</strong></p>
<p>1. 不要执着于一个位置，学会补位</p>
<p>2. 多看小地图，优势路帮优不帮劣</p>
<p>3. 团战目标明确：切后排、保后排、控关键人物</p>
<p>4. 经济领先时主动开龙，扩大优势</p>
<p>祝大家新赛季早日上王者！</p>`,
    categorySlug: 'youxi',
    author: '荣耀王者老陈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20gamer%20avatar%20with%20golden%20crown%2C%20teal%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20confident%20expression%2C%20clean%20edges&width=100&height=100&seq=avatar-a13&orientation=squarish',
    publishDate: '2026-07-23',
    views: 387000,
    likes: 108000,
    comments: 8670,
    duration: '06:30',
    tags: ['游戏', '王者荣耀', '攻略', '上分'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20mobile%20game%20battle%20scene%20with%20fantasy%20characters%20clashing%20in%20a%20Chinese%20style%20arena%2C%20dramatic%20lighting%2C%20action%20packed%2C%20cinematic%20composition%2C%20vibrant%20colors%2C%20game%20art%20style&width=800&height=450&seq=article-thumb-a13&orientation=landscape',
    featured: false,
  },
  {
    id: 'a14',
    title: '如何用手机拍出电影感Vlog？这5个技巧让你的视频瞬间高级',
    excerpt: '不需要昂贵的设备！用手机就能拍出电影质感的Vlog，分享5个专业级拍摄技巧。',
    content: `<p>很多人觉得拍好Vlog一定要买很贵的相机和镜头，其实完全不是！你口袋里的手机就是一台强大的拍摄工具。今天教大家5个技巧，让你的手机Vlog瞬间提升质感。</p>
<p><strong>技巧一：稳定压倒一切</strong></p>
<p>电影感和业余感最大的区别就是画面是否稳定。买个手机稳定器（几百块就能买到不错的），或者用手持技巧——双手握手机，手肘夹紧身体两侧，用身体带动镜头移动而不是只转手腕。</p>
<p><strong>技巧二：善用光线</strong></p>
<p>黄金拍摄时间是日出后一小时和日落前一小时。这时的光线柔和温暖，自带滤镜效果。尽量避免正午顶光拍摄，如果在室内，找一个有大窗户的地方，让自然光从侧面照过来。</p>
<p><strong>技巧三：三分构图法</strong></p>
<p>打开手机的网格线功能，把画面分成九宫格。把主体放在线条交叉点上，画面会更有层次感。拍人物时，眼睛位置放在上方三分线处最自然。</p>
<p><strong>技巧四：前景遮挡转场</strong></p>
<p>这是最简单但效果最好的转场技巧。从一个场景结束时，把镜头靠近一个物体（比如墙壁、树干）直到画面全黑，然后下一个场景从黑色中拉出来。瞬间就有了电影级的过渡效果。</p>
<p><strong>技巧五：慢动作捕捉细节</strong></p>
<p>用手机的慢动作模式拍摄一些细节：咖啡倒入杯中的瞬间、风吹动树叶、走路时鞋子踩在地上的特写。这些镜头穿插在Vlog中，氛围感直接拉满。</p>
<p>赶紧拿起手机试试吧，你也可以拍出电影感满满的Vlog！</p>`,
    categorySlug: 'zhishi',
    author: 'Vlog达人阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20videographer%20avatar%20holding%20smartphone%2C%20warm%20brown%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20creative%20look%2C%20clean%20edges&width=100&height=100&seq=avatar-a14&orientation=squarish',
    publishDate: '2026-07-22',
    views: 212000,
    likes: 62300,
    comments: 4567,
    duration: '05:40',
    tags: ['教程', 'Vlog', '拍摄', '手机', '技巧'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20person%20filming%20with%20smartphone%20on%20a%20gimbal%20stabilizer%20in%20a%20beautiful%20outdoor%20setting%2C%20golden%20hour%20sunset%20lighting%2C%20cinematic%20composition%2C%20urban%20park%20background%2C%20creative%20lifestyle%2C%20photorealistic&width=800&height=450&seq=article-thumb-a14&orientation=landscape',
    featured: false,
  },
  {
    id: 'a15',
    title: '晨跑365天的变化：从油腻大叔到阳光型男',
    excerpt: '坚持晨跑一整年，体重从90kg降到72kg，不仅身材变好了，整个人生状态都焕然一新。',
    content: `<p>一年前，我站在体重秤上看到90kg的数字时，终于下定决心改变。那时候的我，每天加班到深夜，外卖当饭吃，周末就是躺着刷手机。体检报告上的红字越来越多。</p>
<p>今天我跑完了第365次晨跑，体重72kg。想和大家分享这一年的变化。</p>
<p><strong>第一个月：痛苦挣扎</strong></p>
<p>刚开始跑步真的是煎熬。跑不到500米就喘得不行，小腿酸痛，第二天差点起不来床。但我告诉自己：至少坚持一个月。咬牙挺过了最难的阶段。</p>
<p><strong>第三个月：开始享受</strong></p>
<p>身体逐渐适应了，从跑1公里到能轻松跑5公里。更重要的是，我开始享受晨跑的感觉——清晨的空气、安静的街道、日出时的天空，这种感觉会上瘾。</p>
<p><strong>第六个月：明显变化</strong></p>
<p>体重降到了80kg，同事们都问我是不是去健身了。精神状态比以前好了太多，工作效率也提高了。最重要的是，睡眠质量变好了，不再失眠。</p>
<p><strong>第十二个月：脱胎换骨</strong></p>
<p>72kg，体脂率从28%降到15%。跑步配速从8分钟/公里提升到5分半。但更大的变化是心态——我变得更自律、更积极、更有耐心。</p>
<p>如果你也想要改变，我的建议是：不要想太多，明天早上就穿上跑鞋出门。哪怕只跑10分钟，也比躺着强一万倍。</p>`,
    categorySlug: 'yundong',
    author: '跑步哥阿强',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20runner%20avatar%2C%20athletic%20character%2C%20orange%20warm%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20energetic%20smile%2C%20clean%20edges&width=100&height=100&seq=avatar-a15&orientation=squarish',
    publishDate: '2026-07-21',
    views: 312000,
    likes: 94500,
    comments: 7230,
    duration: '04:18',
    tags: ['运动', '跑步', '健身', '蜕变', '坚持'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20person%20running%20on%20a%20scenic%20trail%20at%20sunrise%2C%20golden%20morning%20light%2C%20fitness%20transformation%20theme%2C%20healthy%20active%20lifestyle%2C%20inspiring%20atmosphere%2C%20nature%20background%2C%20photorealistic&width=800&height=450&seq=article-thumb-a15&orientation=landscape',
    featured: false,
  },
  {
    id: 'a16',
    title: '收养了一只流浪狗，它用一生来报答我的善意',
    excerpt: '在回家的路上遇到了一只浑身脏兮兮的流浪狗，带它回家的那一刻，我们都获得了新生。',
    content: `<p>那天晚上加班到很晚，下着小雨。走到小区门口的时候，我发现垃圾桶旁边缩着一团毛茸茸的东西。走近一看，是一只瘦得皮包骨头的小狗，浑身脏兮兮的，但眼睛亮亮的。</p>
<p>它看到我，没有躲开，反而小心翼翼地摇了摇尾巴，那眼神好像在说："能带我回家吗？"</p>
<p>犹豫了大概三秒钟，我蹲下来伸出手，它就把头蹭了过来。那一刻，我的心都化了。</p>
<p>带它去宠物医院检查，医生说大概一岁左右，是只田园犬串串，营养不良但整体健康。洗完澡驱完虫后，它露出了本来的样子——一身金黄色的短毛，居然还挺好看。</p>
<p>我给它起名叫"小幸运"，因为遇到它是我那天最大的幸运。</p>
<p>现在小幸运来我家已经半年了。它特别懂事，从来不在家里大小便，不乱叫，不拆家。每次我下班回家，它都会叼着自己的玩具在门口等我。周末的时候，它就安安静静地趴在我脚边，偶尔抬头用那双亮亮的眼睛看我一眼。</p>
<p>有时候我在想，到底是我救了它，还是它救了我。在这个孤独的城市里，有小幸运陪着，日子变得温暖了许多。</p>
<p>希望大家以领养代替购买，每一只流浪动物都值得被温柔对待。</p>`,
    categorySlug: 'chongwu',
    author: '幸运妈妈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cartoon%20style%20animal%20lover%20avatar%20hugging%20a%20dog%2C%20teal%20green%20background%2C%20simple%20minimalist%20design%2C%20flat%20illustration%2C%20warm%20heartfelt%20expression%2C%20clean%20edges&width=100&height=100&seq=avatar-a16&orientation=squarish',
    publishDate: '2026-07-20',
    views: 267000,
    likes: 78900,
    comments: 6234,
    duration: '03:45',
    tags: ['宠物', '流浪狗', '领养', '温暖', '治愈'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20golden%20mixed%20breed%20dog%20sitting%20happily%20next%20to%20its%20owner%20in%20a%20cozy%20living%20room%2C%20warm%20evening%20light%20from%20window%2C%20heartwarming%20atmosphere%2C%20love%20and%20companionship%2C%20photorealistic&width=800&height=450&seq=article-thumb-a16&orientation=landscape',
    featured: false,
  },
];

export const getArticleById = (id: string) => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (slug: string) => {
  return articles.filter((a) => a.categorySlug === slug);
};

export const getFeaturedArticles = () => {
  return articles.filter((a) => a.featured);
};

export const getPopularArticles = (limit: number = 6) => {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, limit);
};